import React from 'react';

const AuthFormCard = ({ title, children, footer }) => {
  return (
    <div className="content-wrapper xl:bg-white dark:bg-dark-white xl:px-7 px-5 2xl:px-[164px] xl:w-[828px] 2xl:w-[828px] py-12 rounded-xl flex flex-col justify-center">
      <div>
        {/* Title */}
        {title && (
          <div className="title-area flex flex-col justify-center items-center relative text-center mb-7">
            <h1 className="sm:text-5xl text-4xl font-bold text-dark-gray dark:text-white leading-2">
              {title}
            </h1>
          </div>
        )}

        {/* Form content */}
        {children}

        {/* Footer — button + nav links */}
        {footer && (
          <div className="flex flex-col items-center mt-8">{footer}</div>
        )}
      </div>
    </div>
  );
};

export default AuthFormCard;
